export interface ServiceContainer {
  get<T>(key: string): T;
  register<T>(key: string, factory: () => T): void;
  singleton<T>(key: string, factory: () => T): void;
}

class DIContainer implements ServiceContainer {
  private services = new Map<string, () => any>();
  private singletons = new Map<string, any>();

  get<T>(key: string): T {
    if (this.singletons.has(key)) {
      return this.singletons.get(key);
    }

    const factory = this.services.get(key);
    if (!factory) {
      throw new Error(`Service ${key} not found`);
    }

    return factory();
  }

  register<T>(key: string, factory: () => T): void {
    this.services.set(key, factory);
  }

  singleton<T>(key: string, factory: () => T): void {
    const instance = factory();
    this.singletons.set(key, instance);
  }
}

export const container = new DIContainer();
